import { generateDataTable, generateHtml } from '../../report-common';

export default {
  data() {
    return {
      isSelect: false,
    };
  },
  props: ['option', 'componentSelect', 'index', 'bodyLength'],
  watch: {
    componentSelect(n) {
      if (n === this.option.component_id) this.isSelect = true;
      else this.isSelect = false;
    },
  },
  render(createElement) {
    const self = this;
    if (self?.option?.elements?.length) {
      let subTitleIndex = 0;
      const classes = ['body_component', 'go-report-section'];
      if (self.isSelect) classes.push('component_select');
      if (self.index === 0) classes.push('introduction');
      if (self.index === self.bodyLength - 1) classes.push('conclusion');
      return createElement(
        'div',
        {
          class: classes,
          on: {
            click() {
              self.isSelect = true;
              self.$emit('selectBody', self.option.component_id, self.option.reference_doc_ids);
            },
          },
        },
        self?.option?.elements.map(function (item) {
          switch (item.element_type) {
            case 'heading':
              return createElement(
                'h2',
                {
                  class: ['font-bold'],
                },
                `${self.index + 1}. ${item.content || ''}`
              );
            case 'subheading':
              if (item.content) {
                subTitleIndex++;
                return createElement('ul', { class: ['go-report-list-decimal'] }, [
                  createElement('li', [
                    createElement(
                      'h3',
                      {
                        class: ['font-bold'],
                      },
                      `${self.index + 1}-${subTitleIndex}. ${item.content || ''}`
                    ),
                  ]),
                ]);
              }
              break;
            case 'list':
              if (item.content?.length > 0) {
                return createElement(
                  'ul',
                  { class: ['go-report-list-decimal'] },
                  item.content.map(function (text) {
                    return createElement('li', [createElement('p', text || '')]);
                  })
                );
              } else return createElement('div');
            case 'table':
              return createElement('table', {
                class: ['go-report-table'],
                domProps: {
                  innerHTML: generateDataTable(item?.content?.schema, item?.content?.data).innerHTML,
                },
              });
            case 'list-of-list':
              if (item.content?.length > 0) {
                return createElement('div', {
                  domProps: {
                    innerHTML: generateHtml(item?.content).innerHTML,
                  },
                });
              } else return createElement('div');
          }
        })
      );
    }
  },
};
